module.exports = __webpack_public_path__ + "img/7.80638643.png";